<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    /* 判断本地保存当前页面，进行相应页面跳转 */
    /* 主要为解决：未退出，直接关闭浏览器，再次输入网址后，当前页面与右侧导航不一致问题 */
    let index = Number(localStorage.getItem('current'))-1
    let data=['/','/userCenter','/usage','/pricingCenter','/activationCode','/workOrder']
    this.$router.push(data[index])
  },
}
</script>

<style>
#app {
height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue